import { auth, db } from "../firebase/config";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";


// Register user
export const registerUser = async(
  fullName: string,
  email: string,
  phone: string,
  password: string
  
) => {
  try {

     // 1. Create user in Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;

     // 2. Get a fresh token — ensures auth is fully ready before Firestore write
    await user.getIdToken();

    // 3. Save extra data in Firestore
    await setDoc(doc(db, "users", user.uid),
  {
    userId: user.uid,
    fullName,
    email,
    phone,
    role: "client",
    accountStatus: "pending", // ← pending until admin approves
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });

  return user;

  } catch (error: any){

    throw error;
  }
  
};


// ── LOGIN ─────────────────────────────────────────────────
export const loginUser = async (email: string, password: string) =>{
  try{
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    
    return userCredential.user;

  } catch (error: any){
    throw error
  }
}

// ── LOGOUT ────────────────────────────────────────────────
export const logoutUser = async () => {
  await signOut(auth);
};